module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/issue-04-1a97ebbf082a8f028ec7c62fa3e26224.png";